// src/components/StatusBadge.js
import React from "react";
import { ORDER_STATUSES } from "../config";

export default function StatusBadge({ status }) {
  const info = ORDER_STATUSES[status] || { label: status, color: "#64748b" };
  return (
    <span className={`badge badge-${status}`}>
      <span className="badge-dot" />
      {info.label}
    </span>
  );
}
